import React from "react";
import { Breadcrumb, List, Radio } from "antd";
import { Link } from "react-router-dom"
import LogoWithoutText from "../../../assets/images/logos/logo-metropolis-symbol.svg";
import "./Appointment.css";
import { SVGicon } from "../../../styleGuide/SVGicon/SVGicon";
import { Helmet } from "react-helmet";


export const Appointment = () => {
     return (
          <>
               <Helmet>
                    <title>Appointment | Metropolis</title>
               </Helmet>
               <section className="appointment ground-color-ashes">
                    <div className="section-header-lg appointment-header-wrap">
                         <h2 className="section-header-lg-primary-heading  text-color-alpha fw-700">
                              Select Date & Time
                         </h2>
                         <p className="section-header-lg-secondary-text  text-color-bravo fw-400 mt-0">
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                              incididunt ut
                         </p>
                    </div>
                    <div className="mtp-container">
                         <div className="appointment-wrap">
                              <div className="appointment-wrap-head-title d-flex align-center">
                                   <Breadcrumb separator=">">
                                        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
                                        <Breadcrumb.Item href="">Get an Enhanced Profile</Breadcrumb.Item>
                                   </Breadcrumb>
                              </div>
                              <div className="appointment-wrap-content-section">
                                   <div className="enhanced-profile-left-content">

                                        <Link to="/" className="enhanced-profile-left-logo-wrap flex-center flex-auto-0 contain-image">
                                             < img src={LogoWithoutText} alt="footer-logo" />
                                        </Link>
                                        <h6 className="enhanced-profile-left-title fw-600">Metropolis Demo</h6>
                                        <List className="enhanced-profile-list">
                                             <List.Item className="enhanced-profile-list-item">
                                                  <span className="enhanced-profile-playIcon flex-center  flex-center-auto-0 contain-image">
                                                       {SVGicon.mtpIconClock}
                                                  </span>
                                                  <span>30 Min</span>
                                             </List.Item>
                                             <List.Item className="enhanced-profile-list-item">
                                                  <span className="enhanced-profile-playIcon flex-center  flex-center-auto-0 contain-image">
                                                       {SVGicon.mtpIconLocation}
                                                  </span>
                                                  <span>A Metro Team Member will reach out and added
                                                       a zoom link to your calendar invite  </span>
                                             </List.Item>
                                             <List.Item className="enhanced-profile-list-item">
                                                  <span className="enhanced-profile-playIcon flex-center  flex-center-auto-0 contain-image">
                                                       {SVGicon.mtpIconCalendar}
                                                  </span>
                                                  <span>2:30pm - 3:00pm, Thursday, November 17, 2022</span>
                                             </List.Item>
                                             <List.Item className="enhanced-profile-list-item">
                                                  <span className="enhanced-profile-playIcon flex-center  flex-center-auto-0 contain-image">
                                                       {SVGicon.mtpIconMountainTime}
                                                  </span>
                                                  <span>Mountain Time - US & Canada</span>
                                             </List.Item>

                                        </List>

                                   </div>
                                   <div className="appointment-wrap-divider "></div>
                                   <div className="enhanced-profile-right-content">
                                        <div className="appointment-date-wrap">
                                        </div>
                                        <div className="appointment-wrap-divider "></div>
                                        <div className="appointment-time-wrap">
                                             <h6 className="appointment-time-title fw-600">Wednesday,November 2022</h6>
                                             <div className="appointment-select-time-wrap">
                                                  <Radio.Group defaultValue="a">
                                                       <div className="appointment-select-time-grid">
                                                            <div><Radio.Button value="a" className="mtp-radio-btn ">1:00 PM</Radio.Button></div>
                                                            <div><Radio.Button value="b" className="mtp-radio-btn ">1:30 PM</Radio.Button></div>
                                                            <div><Radio.Button value="c" className="mtp-radio-btn ">2:00 PM</Radio.Button></div>
                                                            <div> <Radio.Button value="d" className="mtp-radio-btn ">4:00 PM</Radio.Button> </div>
                                                            <div>   <Radio.Button value="e" className="mtp-radio-btn ">4:30 PM</Radio.Button></div>
                                                            <div> <Radio.Button value="f" className="mtp-radio-btn">5:00 PM</Radio.Button></div>
                                                            <div>  <Radio.Button value="g" className="mtp-radio-btn ">7:00 PM</Radio.Button></div>
                                                            <div><Radio.Button value="h" className="mtp-radio-btn">7:30 PM</Radio.Button></div>
                                                       </div>
                                                  </Radio.Group>
                                             </div>
                                             <div className="appointment-select-time-btn-wrap flex-center">
                                                  <Link className="confirm-btn cancel-btn mr-5" > Cancel </Link>
                                                  <Link to="/AppointmentEnterDetails" className="confirm-btn " type="prime" > Confirm </Link>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </section>
          </>
     )
}